import { Reducer } from "react";

import { WizardStep } from "./WizardStep";

export interface WizardState {
  steps: WizardStep[];
  currentStepIndex: number;
}

export type WizardAction =
  | { type: "GO_TO_PREV_STEP" }
  | { type: "GO_TO_NEXT_STEP" }
  | { type: "GO_TO_STEP_BY_KEY"; key: string };

export const wizardReducer: Reducer<WizardState, WizardAction> = (state, action) => {
  switch (action.type) {
    case "GO_TO_PREV_STEP":
      return {
        ...state,
        currentStepIndex: state.currentStepIndex - 1,
      };
    case "GO_TO_NEXT_STEP":
      return {
        ...state,
        currentStepIndex: state.currentStepIndex + 1,
      };
    case "GO_TO_STEP_BY_KEY": {
      const step = state.steps.find(s => s.key == action.key)!;

      return {
        ...state,
        currentStepIndex: state.steps.indexOf(step),
      };
    }
    default:
      return { ...state };
  }
};
